import PropTypes from "prop-types";

/**
 * PropTypes for PairPOSModal component.
 *
 * @property {boolean} isOpen - Whether the modal is open
 * @property {Function} onClose - Close handler
 * @property {string} [pairingCode] - Initial pairing code to display
 * @property {string|number} [operatorId] - Operator identifier used in pairing
 * @property {Function} [onSuccess] - Callback invoked after successful pairing
 * @property {Function} [addToast] - Toast dispatcher for feedback
 */
export const pairPosModalPropTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  pairingCode: PropTypes.string,
  operatorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSuccess: PropTypes.func,
  addToast: PropTypes.func,
};

/**
 * PropTypes for Terminal sidebar section (filters/details/actions).
 *
 * @property {Object|null} [selectedTerminal] - Currently selected terminal (or null)
 * @property {Function} onClearSelection - Handler to return to filters
 * @property {Object} filters - Current filter state
 * @property {Function} onFilterChange - Filter change dispatcher
 * @property {number} visibleCount - Number of visible terminals after filtering
 * @property {Function} onDelete - Handler to delete a terminal
 * @property {Array<Object>} terminals - List of terminals available
 * @property {Function} [onUnpairTerminal] - Handler to unpair a terminal
 * @property {boolean} [isUnpairingLoading] - Unpair action loading state
 */
export const terminalSidebarSectionPropTypes = {
  selectedTerminal: PropTypes.oneOfType([PropTypes.object, PropTypes.oneOf([null])]),
  onClearSelection: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  visibleCount: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
  terminals: PropTypes.arrayOf(PropTypes.object).isRequired,
  onUnpairTerminal: PropTypes.func,
  isUnpairingLoading: PropTypes.bool,
};

/**
 * PropTypes for TerminalManagement view.
 * The component is self-contained and does not accept configurable props yet.
 */
export const terminalManagementPropTypes = {};
